import {UserInOverview} from '@/components/user/overview';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface UserSliceState {
  userDataByEmail: Record<string, UserInOverview>;
}

const initialState: UserSliceState = {
  userDataByEmail: {}
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData(
      state,
      action: PayloadAction<{email: string; data: UserInOverview}>
    ) {
      const {email, data} = action.payload;
      state.userDataByEmail[email] = data;
    }
  }
});

export const {setUserData} = userSlice.actions;

export default userSlice.reducer;
